<script>
    import { metaInfo } from "@/core/MetaInfo";

    export default {
        name: "PromoList",
        data() {
            return {
                list: [],
                isLoading: true,
            };
        },
        mounted() {
            this.getList();
        },
        methods: {
            selected(item) {
                this.$router.push({ name: "PromoEdit", params: { slug: item.id } });
            },
            getList() {
                this.$store.autoAdminApi.getPromoList().then(({ data }) => {
                    this.list = data.items;
                    this.isLoading = false;
                });
            },
        },
        metaInfo() {
            return metaInfo.getMeta("home");
        },
    };
</script>

<template>
    <section class="section">
        <div class="field">
            <b-button tag="router-link" to="/promo/new" type="is-primary" outlined>
                Добавить промо
            </b-button>
        </div>

        <h1 class="title">Список промо</h1>

        <b-table :data="list" @select="selected" hoverable>
            <b-loading
                v-model="isLoading"
                :can-cancel="true"
                :is-full-page="false"
            ></b-loading>

            <b-table-column field="name" label="Название" sortable width="80" v-slot="props">
                {{ props.row.name }}
            </b-table-column>
            <b-table-column field="id" label="Id" width="60" v-slot="props">
                {{ props.row.id }}
            </b-table-column>
        </b-table>
    </section>
</template>

<style lang="scss"></style>
